import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { CreateAccountPage } from "./CreateAccountPage";
import { BIBlue } from "../../assets/helpers";
import CryptoJS from "crypto-js";
import { ProfilePage } from "./ProfilePage";
import { TradeAndProfilePage } from "./TradeAndProfilePage";
import { Postrequestcall } from "../../request/Postrequest";
import packageInfo from "../../../package.json";
import {
  CREATE_NEW_ACCOUNT,
  GETUSERINFO,
  LOGIN,
  SAVE_USER_REFERRALS,
  CLIENT_DETAILS_BY_USERID_NEW,
  CLIENT_SAVE_INVITATIONS
} from "../../constant/Apipath";
import moment from "moment";
import {
  setLogindata,
  setSelectedClientdata,
  setShowalert,
  setShowmapmodal
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { ExperiencePage } from "./ExperiencePage";
import { FinishPage } from "./FinishPage";
import Loader from "../../common/Loader";
import BuilderIcon from "../../assets/images/profile_logo.jpg";
import { Getrequestcall } from "../../request/Getrequest";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import TakeTour from "../login/takeatour/TakeTour";
import { fetchAndStoreCommunityPostIds } from "../../services/communityService";
import { SelectOrganizationDialog } from "../login/SelectOrganization";
import ClientInvitation from "../../client/invitation/ClientInvitation";
import { clearIndexDB } from "../../db";

const PAGE = {
  createNewAccount: "create-new-account",
  profilePage: "profile-page",
  tradeprofilepage: "trade-profile-page",
  experiencePage: "experience-page",
  finishPage: "finish-page",
  loadingPage: "loading-page"
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Createaccount() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [activePage, setActivePage] = useState(null);
  const [companyId, setCompanyId] = useState(0);
  const [searchTerm, setSearchTerm] = useState({
    city: "",
    country: "",
    latitude: "",
    longitude: ""
  });
  const [emailError, setEmailError] = useState(false);
  const [fnameError, setFnameError] = useState(false);
  const [lnameError, setLnameError] = useState(false);
  const [openTour, setOpenTour] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const { referId } = useParams();

  useEffect(() => {
    if (state?.email) {
      setEmail(state.email);
    }
    const clientData = Array.isArray(state?.clientData) ? state.clientData[0] : state?.clientData;
    if (clientData) {
      if (clientData.clientEmployeeName) {
        const nameParts = clientData.clientEmployeeName.trim().split(/\s+/);
        if (nameParts.length > 0) {
          setFirstName(nameParts[0]);
          if (nameParts.length > 1) {
            setLastName(nameParts.slice(1).join(" "));
          }
        }
      } else {
        if (clientData.FirstName) setFirstName(clientData.FirstName);
        if (clientData.LastName) setLastName(clientData.LastName);
      }
    }
  }, [state]);
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const handleShowAlert = (message) => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: message
    };
    dispatch(setShowalert(alertObj));
  };

  async function handleCreateAccountClick() {
    if (email === "") {
      setEmailError(true);
      return;
    }

    if (email !== "" && !EMAIL_REGEX.test(email)) {
      setEmailError(true);
      return;
    }

    if (firstName === "" || /^\s*$/.test(firstName)) {
      setFnameError(true);
      return;
    }

    if (lastName === "" || /^\s*$/.test(lastName)) {
      setLnameError(true);
      return;
    }

    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal));

    setActivePage(PAGE.loadingPage);
    try {
      const hashPassword = CryptoJS.SHA256(password).toString();
      let newAccountObj = {
        UserEmail: email,
        Password: hashPassword,
        FirstName: firstName,
        LastName: lastName,
        ReferredBy: pathname.includes("/refer") ? referId : "",
        ReferredSource: ""
      };
      const createAccountRes = await Postrequestcall(CREATE_NEW_ACCOUNT, newAccountObj, null);

      if (createAccountRes?.data?.errorMessage && createAccountRes?.data?.status === false) {
        handleShowAlert(createAccountRes?.data?.errorMessage);
        setActivePage(PAGE.createNewAccount);
      } else if (createAccountRes?.status === 201 && createAccountRes?.data?.data?.id) {
        try {
          const loginObj = {
            AppName: "BuilldID Web",
            Email: email,
            Password: hashPassword,
            LoginWith: "Password",
            IdentityToken: "",
            NotifyToken: "",
            DeviceName: "Browser",
            AppVersion: packageInfo?.version,
            Platform: "Web",
            PlatformVersion: ""
          };
          let loginResp = await Postrequestcall(LOGIN, loginObj, null);
          if (loginResp.data?.message === "OK" && loginResp?.data?.status === true) {
            if (pathname.includes("/refer") && referId) {
              const payload = {
                ReturnRecordId: true,
                ReturnRecordError: true,
                SaveList: [
                  {
                    ReferralCode: referId,
                    ReferredSource: "BI_user"
                  }
                ]
              };
              await Postrequestcall(
                SAVE_USER_REFERRALS,
                payload,
                loginResp?.data?.data?.accessToken
              );
            }
            if (state?.invitationStatus && state?.clientId) {
              const inviteObj = {
                id: 0,
                ClientId: Number(state.clientId),
                UserEmail: email,
                Date: moment(),
                Status: state.invitationStatus,
                Description: "User",
                GuideId: ""
              };
              await Postrequestcall(
                CLIENT_SAVE_INVITATIONS,
                inviteObj,
                loginResp?.data?.data?.accessToken
              );
            }
            clearIndexDB();
            getUserinformation(loginResp?.data?.data);
          }
        } catch (error) {
          console.log("handleCreateAccountClick (LOGIN) ->Error In Login API: ", error);
          setActivePage(PAGE.createNewAccount);
        }
      }
    } catch (error) {
      console.log(
        "handleCreateAccountClick (CREATE ACCOUNT)-> Error When Creating Account: ",
        error || error?.message || error?.errorMessage
      );
      setActivePage(PAGE.createNewAccount);
    }
  }

  const [showClientModal, setShowClientModal] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [pendingLoginRes, setPendingLoginRes] = useState(null);
  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const getUserinformation = async (loginRes) => {
    let getResponse = await Getrequestcall(
      `${GETUSERINFO}/${loginRes?.userInformation?.UserId}`,
      loginRes?.accessToken
    );
    if (getResponse?.status === 200) {
      let getDetail = getResponse?.data?.data;

      let clientListFromApi = loginRes?.userInformation?.ClientsList;
      let invites = [];
      try {
        const detailPayload = {
          UserId: Number(loginRes?.userInformation?.UserId),
          UserEmail: loginRes?.userInformation?.Email
        };
        const detailRes = await Postrequestcall(
          CLIENT_DETAILS_BY_USERID_NEW,
          detailPayload,
          loginRes?.accessToken
        );
        console.log("CLIENT_DETAILS_BY_USERID_NEW Response (Create Account):", detailRes);
        if (detailRes?.data?.Data?.ClientsList) {
          clientListFromApi = detailRes.data.Data.ClientsList;
        }
        if (detailRes?.data?.Data?.ClientInvitation) {
          invites = detailRes.data.Data.ClientInvitation;
        }
      } catch (error) {
        console.log("CLIENT_DETAILS_BY_USERID_NEW Error (Create Account):", error);
      }

      let getClientlist = clientListFromApi?.filter(
        (item) =>
          item?.InvitationStatus === "Accepted" &&
          item?.ClientId !== 0 &&
          item?.ClientEmployeeId !== 0
      );

      const buildIDObj = {
        ClientId: 0,
        AccentColor: BIBlue,
        OrganizationName: "BuildID Free",
        ClientLogo: BuilderIcon,
        HideBiFree: false // Ensure this property exists
      };

      // getClientlist.push(buildIDObj);
      let getObj = {
        ...loginRes,
        userInformation: {
          ...loginRes.userInformation,
          FirstName: getDetail?.firstName,
          LastName: getDetail?.lastName,
          TradeName: getDetail?.tradeName,
          ClientsList: getClientlist,
          PendingInvitations: invites
        }
      };

      // Logic to check for clients/invites
      const hasClients = getClientlist.some((c) => c.HideBiFree); // Check if real clients exist
      const hasInvites = invites.length > 0;

      if (hasClients || hasInvites) {
        setPendingLoginRes(getObj);
        const clientsForModal = getClientlist.filter((c) => c.OrganizationName !== "BuildID Free");
        setClientList(clientsForModal);
        setShowClientModal(true);
      } else {
        // Default flow if no specific clients/invites
        dispatch(setLogindata({ ...getObj, sourceDataFrom: "Create Account" }));
        dispatch(setSelectedClientdata(buildIDObj));
        fetchAndStoreCommunityPostIds(
          getObj?.userInformation?.UserId,
          getObj?.accessToken,
          dispatch
        );
        setOpenTour(true);
      }
    }
  };

  const handleSelectClient = async (client) => {
    dispatch(setLogindata(pendingLoginRes));
    dispatch(setSelectedClientdata(client));
    fetchAndStoreCommunityPostIds(
      pendingLoginRes?.userInformation?.UserId,
      pendingLoginRes?.accessToken,
      dispatch
    );
    if (client.ClientId && client.ClientId !== 0) {
      navigate(`/client/${client.ClientId}/home`);
    } else {
      navigate("/home");
    }
    setShowClientModal(false);
  };

  const handleLogoutInModal = () => {
    setShowClientModal(false);
    setPendingLoginRes(null);
    setClientList([]);
    localStorage.setItem("ShowTradeModal", false);
    // Maybe redirect to login or just close?
    navigate("/");
  };

  const handleViewPendingInvite = (invite) => {
    const updatedUserInfo = {
      ...pendingLoginRes,
      userInformation: {
        ...pendingLoginRes.userInformation,
        ClientInvitation: {
          ClientId: invite.ClientId,
          Status: 1
        }
      }
    };
    setPendingLoginRes(updatedUserInfo);
    setShowClientModal(false);
    setShowInvitationModal(true);
  };

  const handleInviteModalClose = async () => {
    setShowInvitationModal(false);
    // Refresh user info
    await getUserinformation(pendingLoginRes);
  };

  const activeForm = () => {
    switch (activePage) {
      case PAGE.createNewAccount:
        return (
          <CreateAccountPage
            firstName={firstName}
            lastName={lastName}
            email={email}
            emailError={emailError}
            fnameError={fnameError}
            lnameError={lnameError}
            password={password}
            disableEmail={!!state?.email}
            organizationName={
              (Array.isArray(state?.clientData) ? state.clientData[0]?.organizationName : null) ||
              state?.clientData?.organizationName
            }
            clientLogo={
              (Array.isArray(state?.clientData) ? state.clientData[0]?.clientLogo : null) ||
              state?.clientData?.clientLogo ||
              state?.clientData?.Logo ||
              state?.clientData?.ClientLogo
            }
            handlFirstNameInput={(event) => {
              setFnameError(false);
              setFirstName(event.target.value);
            }}
            handleLastNameInput={(event) => {
              setLnameError(false);
              setLastName(event.target.value);
            }}
            handleEmailInput={(event) => {
              setEmailError(false);
              const value = event.target.value;
              setEmail(value);
            }}
            handlePasswordInput={(event) => setPassword(event.target.value)}
            handleCreateAccountClick={handleCreateAccountClick}
          />
        );
      case PAGE.profilePage:
        return (
          <ProfilePage
            firstName={firstName}
            lastName={lastName}
            email={email}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            handleFirstNameInput={(event) => setFirstName(event.target.value)}
            handleLastNameInput={(event) => setLastName(event.target.value)}
            gotoTradeAndProfilePage={() => setActivePage(PAGE.tradeprofilepage)}
            openProfilePage={() => setActivePage(PAGE.profilePage)}
            loadingPage={() => setActivePage(PAGE.loadingPage)}
          />
        );
      case PAGE.tradeprofilepage:
        return (
          <TradeAndProfilePage
            firstName={firstName}
            lastName={lastName}
            email={email}
            setCompanyId={setCompanyId}
            gotoExperiencePage={() => setActivePage(PAGE.experiencePage)}
            openTradeProfilePage={() => setActivePage(PAGE.tradeprofilepage)}
            loadingPage={() => setActivePage(PAGE.loadingPage)}
            // handleFirstNameInput={(event) => setFirstName(event.target.value)}
            // handleLastNameInput={(event) => setLastName(event.target.value)}
          />
        );
      case PAGE.experiencePage:
        return (
          <ExperiencePage
            companyId={companyId}
            searchTerm={searchTerm}
            gotoFinishPage={() => setActivePage(PAGE.finishPage)}
            openExperiencePage={() => setActivePage(PAGE.experiencePage)}
            loadingPage={() => setActivePage(PAGE.loadingPage)}
          />
        );
      case PAGE.finishPage:
        return <FinishPage />;
      case PAGE.loadingPage:
        return <Loader fullScreen={true} />;
      default:
        break;
    }
  };

  useEffect(() => {
    let alertObj = {
      showAlert: false,
      title: "",
      text: ""
    };
    dispatch(setShowalert(alertObj));
    if (pathname?.includes("/refer")) {
      if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
        // const url = `https://mybuilderid.onelink.me/hhPN?af_web_dp=https%3A%2F%2Fbimiscwebapi-web-user-production.azurewebsites.net%2Fcreate-account&af_xp=custom&pid=BI_user&af_dp=mybuilderid%3A%2F%2F&deep_link_value=${referId}`;
        //const url = `https://mybuilderid.onelink.me/hhPN?af_web_dp=https%3A%2F%2Fbimiscwebapi-web-user-production.azurewebsites.net%2Fcreate-account&af_xp=custom&pid=BI_user&af_dp=mybuilderid%3A%2F%2F&af_force_deeplink=true&deep_link_value=${referId}`;
        const url = `https://mybuilderid.onelink.me/hhPN?af_web_dp=https%3A%2F%2Fbimiscwebapi-web-user-production.azurewebsites.net%2Fcreate-account&af_xp=custom&pid=BI_user&af_dp=mybuilderid%3A%2F%2F&is_retargeting=true&af_reengagement_window=1h&af_force_deeplink=true&deep_link_value=${referId}`;
        window.location.href = url;
        return;
      }
    }
    setActivePage(PAGE.createNewAccount);
  }, []);

  return (
    <>
      {showClientModal && (
        <SelectOrganizationDialog
          open={showClientModal}
          onClose={handleLogoutInModal}
          clients={clientList}
          pendingInvitations={pendingLoginRes?.userInformation?.PendingInvitations || []}
          onSelectClient={handleSelectClient}
          onViewInvite={handleViewPendingInvite}
          onLogout={handleLogoutInModal}
          showLogout={true}
        />
      )}

      {showInvitationModal && (
        <ClientInvitation
          showInvitation={showInvitationModal}
          handleClose={handleInviteModalClose}
          overrideLoginData={pendingLoginRes}
        />
      )}
      <Container
        maxWidth="sm"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)" // Centers the container in the viewport
        }}>
        {activeForm()}
      </Container>
      {openTour && (
        <TakeTour fromCreateAccount closeTourFromFinishPage={() => setOpenTour(false)} />
      )}
    </>
  );
}
